var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgExport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.66665V8.66665M7 8.66665L5 6.66665M7 8.66665L9 6.66665M1 9.33331V2.66665C1 1.93027 1.59695 1.33331 2.33333 1.33331H6.33333L7.66667 2.66665H11.6667C12.403 2.66665 13 3.2636 13 3.99998V9.33331C13 10.0697 12.403 10.6666 11.6667 10.6666H2.33333C1.59695 10.6666 1 10.0697 1 9.33331Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/export.db95419a.svg";
export { ForwardRef as ReactComponent };